import { IOrderPageApi, IOrderAppApi, IOrderWS } from '@/types';
import { OrderItem } from '@/models/order';
import { BetSelectionType, MarketType } from '@/constants';

export class OrderFactory {
    static createFromPageApi(data: IOrderPageApi): OrderItem {
        const order = new OrderItem();
        order.id = data.internal_id;
        order.createdAt = data.created_at;
        order.statusId = data.status_id;
        order.closeReasonId = data.close_reason_id;
        order.timeout = data.timeout;
        order.isLive = data.is_live;
        order.periodTypeId = data.period_type_id;
        order.marketTypeId = this.mapBetSelectionTypeToMarketType(data.bet_type_id);
        order.betSelectionId = data.bet_selection_id;
        order.teamHomeName = data.team_home_name;
        order.teamAwayName = data.team_away_name;
        order.leagueName = data.league_name;
        order.correctScore = data.correct_score;
        order.handicap = data.handicap;
        order.jollywhere = data.jollywhere;
        order.score = data.score;
        order.odds = data.odds;
        order.corners = data.corners;
        order.stake = data.stake;
        order.isTopUps = data.is_top_ups;
        order.eventTime = data.time;
        order.customEventId = data.custom_event_id;

        order.betCount = data.bet_count;
        order.betCountWaiting = data.bet_count_waiting;
        order.sumBetStake = data.sum_bet_stake;
        order.sumBetProfit = data.sum_bet_profit;

        order.setCreatedUTC();
        order.calcLeftTime();
        return order;
    }

    static createFromAppApi(data: IOrderAppApi): OrderItem {
        const order = new OrderItem();

        order.id = data.internal_id;
        order.createdAt = data.created_at;
        order.statusId = data.status_id;
        order.closeReasonId = data.close_reason_id;
        order.timeout = data.timeout;
        order.isLive = data.is_live;
        order.periodTypeId = data.period_type_id;
        order.marketTypeId = this.mapBetSelectionTypeToMarketType(data.bet_type_id);
        order.betSelectionId = data.bet_selection_id;
        order.teamHomeName = data.team_home_name;
        order.teamAwayName = data.team_away_name;
        order.leagueName = data.league_name;
        order.correctScore = data.correct_score;
        order.handicap = data.handicap;
        order.jollywhere = data.jollywhere;
        order.score = data.score;
        order.odds = data.odds;
        order.corners = data.corners;
        order.stake = data.stake;
        order.isTopUps = data.is_top_ups;
        order.eventTime = data.time;
        order.customEventId = data.custom_event_id;

        order.betCount = data.bet_count;
        order.betCountWaiting = data.bet_count_waiting;
        order.sumBetStake = data.sum_bet_stake;
        order.sumBetProfit = data.sum_bet_profit;

        order.setCreatedUTC();
        order.calcLeftTime();
        return order;
    }

    static createFromWS(data: IOrderWS): OrderItem {
        const order = new OrderItem();

        order.id = data.internal_id;
        order.createdAt = data.created_at;
        order.statusId = data.status_id;
        order.closeReasonId = data.close_reason_id;
        order.timeout = data.timeout;
        order.isLive = data.is_live;
        order.periodTypeId = data.period_type_id;
        order.marketTypeId = this.mapBetSelectionTypeToMarketType(data.bet_type_id);
        order.betSelectionId = data.bet_selection_id;
        order.teamHomeName = data.team_home_name;
        order.teamAwayName = data.team_away_name;
        order.leagueName = data.league_name;
        order.correctScore = data.correct_score;
        order.handicap = data.handicap;
        order.jollywhere = data.jollywhere;
        order.score = data.score;
        order.odds = data.odds;
        order.corners = data.corners;
        order.stake = data.stake;
        order.isTopUps = data.is_top_ups;
        order.eventTime = data.time;
        order.customEventId = data.custom_event_id;

        order.betCount = data.bet_count;
        order.betCountWaiting = data.bet_count_waiting;
        order.sumBetStake = data.sum_bet_stake;
        order.sumBetProfit = data.sum_bet_profit;

        order.setCreatedUTC();
        order.calcLeftTime();
        return order;
    }

    static mapBetSelectionTypeToMarketType(type: BetSelectionType): MarketType {
        const mapping: Record<BetSelectionType, MarketType> = {
            [BetSelectionType.Handicap]: MarketType.Handicap,
            [BetSelectionType.Goal]: MarketType.Goal,
            [BetSelectionType.OneXTwo]: MarketType.OneXTwo,
            [BetSelectionType.Bts]: MarketType.Bts,
            [BetSelectionType.Dc]: MarketType.Dc,
            [BetSelectionType.Cs]: MarketType.Cs,
            [BetSelectionType.CornersHandicap]: MarketType.CornersHandicap,
            [BetSelectionType.CornersGoal]: MarketType.CornersGoal,
        };

        return mapping[type];
    }
}
